import React from 'react'
import { toast } from 'react-toastify'
import { Button } from '../../../components'
import accountService from '../../../features/account/service'
import auth from '../../../utils/auth'

const ConfirmationPopup = ({data, onClose}) => {
  const [requesting, setRequesting] = React.useState(false)

  const handleClose = (e) => {
    e.preventDefault()
    e.stopPropagation()

    onClose(false)
  }

  const handleDelete = () => {
    console.log({data})
    if(data.accountId && requesting === false){
      setRequesting(true)

      accountService.delete(data.accountId)
        .then(() => {
          auth().logout()
          window.location.href = "/"
        })
        .catch(err => {
          toast.error(err)
        })
        .then(() => setRequesting(false))
    }
  }

  return (
    <div
      className="fixed left-0 top-0 w-full h-screen flex justify-center items-center"
      style={{zIndex: 900, background: 'rgba(0, 0, 0, 0.75)'}}
      onClick={handleClose}
    >
      <div className="container mx-auto" onClick={(e) => e.stopPropagation()}>
        <div className="lg:w-10/12 mx-auto pt-8 pb-5 lg:pt-20 lg:pb-20 px-5 lg:px-24 bg-white rounded overflow-y-auto" style={{maxHeight: '100vh'}}>
          <p className="text-lg lg:text-3xl font-bold">Hapus {data.name}</p>
          <hr className="my-5"/>
          <div className="blog-content my-5 lg:mb-8 lg:mt-10 text-sm">
            <p>Dengan menghapus Halaman Anda, tidak akan ada orang dapat melihat atau menemukannya.</p>
            <p>Anda yakin ingin memulai proses penghapusan halaman ini?</p>
          </div>
          <div className="flex flex-wrap items-center mb-5 lg:mb-8">
            <div className="w-full md:w-auto lg:w-auto">
              <Button
                type="button"
                onClick={handleDelete}
                disabled={requesting}
                isLoading={requesting}
              >
                Hapus Halaman
              </Button>
            </div>
            <div className="w-full md:w-auto lg:w-auto text-center lg:text-left">
              <p className="text-xs lg:text-sm px-8 text-gray-444 underline cursor-pointer" onClick={handleClose}>
                Batal
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export { ConfirmationPopup }
